
interface skillsDataProps {
    name: string;
    percent: string;
}

interface designSkillsProps {
    name: string;
    circle: string;
}

export const frontendSkills: skillsDataProps[] = [

    {
        name: 'JS / Typescript',
        percent: '90%',
    },
    {
        name: 'React',
        percent: '90%',
    },
    {
        name: 'Mobx',
        percent: '85%',
    },
    {
        name: 'Redux',
        percent: '60%',
    },
    {
        name: 'GraphQL',
        percent: '80%',
    },
    {
        name: 'ECMASCRIPT 6',
        percent: '90%',
    },
    {
        name: 'HTML5 / CSS3 / SASS',
        percent: '95%',
    },
    {
        name: 'TAILWIND / MATERIAL',
        percent: '90%',
    },
    {
        name: 'Angular',
        percent: '30%',
    },
    {
        name: 'RESTful APIs',
        percent: '90%',
    },
];

export const backendSkills: skillsDataProps[] = [

    {
        name: 'NODE.JS',
        percent: '70%',
    },
    {
        name: 'RESTful APIs',
        percent: '90%',
    },
    {
        name: '.Net / EF',
        percent: '20%',
    },
    {
        name: 'SQL / MSSMS / Docker',
        percent: '30%',
    },
    
];
export const testingToolsSkills: skillsDataProps[] = [

    {
        name: 'JIRA / ASANA / GIT',
        percent: '70%',
    },
    {
        name: 'SCRUM / AGILE',
        percent: '90%',
    },
    {
        name: 'DESIGN PATTERNS',
        percent: '70%',
    },
    {
        name: 'Performance',
        percent: '80%',
    },
    {
        name: 'Debugging Tools',
        percent: '70%',
    },
];

export const languagesSkills: skillsDataProps[] = [

    {
        name: 'English',
        percent: '85%',
    },
    {
        name: 'Italian',
        percent: '30%',
    },
    {
        name: 'Spanish',
        percent: '10%',
    },
];


export const designSkills: designSkillsProps[] = [
    {
        name: 'Photoshop',
        circle: 'conic-gradient( from 0deg at 50% 50%, var(--primary) 0deg 340deg, rgb(235, 235, 235) 340deg 360deg)'
    },
    {
        name: 'Illustartor',
        circle: 'conic-gradient( from 0deg at 50% 50%, var(--primary) 0deg 350deg, rgb(235, 235, 235) 350deg 360deg)'
    },
    {
        name: 'AFTER EFFECT',
        circle: 'conic-gradient( from 0deg at 50% 50%, var(--primary) 0deg 260deg, rgb(235, 235, 235) 260deg 360deg)'
    },
    {
        name: 'InDesign',
        circle: 'conic-gradient( from 0deg at 50% 50%, var(--primary) 0deg 250deg, rgb(235, 235, 235) 250deg 360deg)'
    },
    {
        name: 'Figma',
        circle: 'conic-gradient( from 0deg at 50% 50%, var(--primary) 0deg 200deg, rgb(235, 235, 235) 200deg 360deg)'
    },
];


export const services: skillsDataProps[] = [
    {
        name: 'WEB DEVELOPMENT',
        percent: '100%',
    },
    {
        name: 'WEB DESIGN',
        percent: '90%',
    },
    {
        name: 'Ui/Ux Design',
        percent: '80%',
    },
    {
        name: 'Branding',
        percent: '70%',
    },
    {
        name: 'Animation',
        percent: '60%',
    },
    {
        name: 'graphic design',
        percent: '80%',
    },

];